import {
  HaLicenseDetail,
  IsFullAccess,
  useAppSelector,
  useGetEntitlementsQuery,
  useGetSystemDataQuery
} from '@monorepo/shared';
import {
  selectCurrentAccount,
  selectEntitlements
} from '@monorepo/shared/store/accountSlice';
import { useNavigate, useParams } from 'react-router-dom';
import { HomeElms, server } from '../../config/const';
import { Button, List, Loader, Modal, Stack } from 'rsuite';
import { useEffect, useState } from 'react';
import CheckOutlineIcon from '@rsuite/icons/CheckOutline';
import { IoCloudUploadOutline } from 'react-icons/io5';
import { ProvisionStatusButton } from './ProvisionStatus';

export const AssetList = () => {
  const { groupId } = useParams();
  const navigate = useNavigate();
  const [items, setItems] = useState<Record<string, any>[]>([]);
  const [trialItem, setTrailItem] = useState<Record<string, any>>({});
  const currentAccount = useAppSelector(selectCurrentAccount);
  const { data: systemData } = useGetSystemDataQuery({ server: server });
  const { data, isError, isSuccess, isLoading, isFetching } =
    useGetEntitlementsQuery(
      {
        server: server,
        account_id: currentAccount.account_id
      },
      { skip: !currentAccount.account_id }
    );
  useEffect(() => {
    if (data) {
      const used_list = data?.used_sn_list || [];
      const used_trial = used_list.find((o: Record<string, any>) => o.is_trial);

      const arr = data?.entitlements
        .map((e: Record<string, any>) => {
          const obj =
            used_list.find(
              (o: Record<string, any>) => o.sn === e.serialNumber
            ) || {};
          return {
            isExpired: new Date() > new Date(e.end_date),
            value: e.serialNumber,
            isDisableProvision:
              !systemData?.allow_multi_inst &&
              used_list?.length > 0 &&
              !obj?.sn,
            isProvisioned: !!obj.instance_id,
            isProvisioning: obj?.sn && !obj.instance_id,
            ...obj
          };
        })
        .sort(
          (a: Record<string, any>, b: Record<string, any>) =>
            Number(a.isProvisioned) - Number(b.isProvisioned)
        );
      setItems(arr);
      // no entitlements and one trial sn in used_sn_list
      if ((!arr.length && used_list?.length === 1) || used_trial) {
        setTrailItem(used_trial || used_list[0]);
      } else {
        setTrailItem({});
      }
      console.info('used_list', used_list, 'entitlements', arr);
    }
  }, [data, systemData]);
  const goToProvision = (sn: string) => {
    navigate(`provision/${sn}`);
  };
  return (
    <>
      <div className="grid-item asset">
        <div className="grid-header">
          <div className="title">
            <i className="icon-fortinetone-knowledgeBase"></i>
            Assets
          </div>
        </div>
        <div className="grid-content">
          {isLoading || isFetching ? (
            <div style={{ height: '100%', position: 'relative' }}>
              <Loader size="xs" content="Loading..." center />
            </div>
          ) : items?.length ? (
            <List size="sm" className="custom-overflow">
              {items.map((item: Record<string, any>, index: number) => (
                <List.Item key={index} index={index}>
                  <Stack justifyContent="space-between">
                    {item.value}
                    <div
                      style={{
                        width: '110px',
                        display: 'grid',
                        placeItems: 'center'
                      }}
                    >
                      {item.isExpired ? (
                        <AssetIndicator
                          account_id={currentAccount.account_id}
                          sn={item?.value}
                          btn_text={'Expired'}
                          btn_color={'red'}
                        />
                      ) : item.isProvisioned ? (
                        <CheckOutlineIcon
                          color="green"
                          title="Provision Success"
                        />
                      ) : item.isProvisioning &&
                        currentAccount?.user_type === 'Master' ? (
                        <ProvisionStatusButton
                          sn={item.value}
                          task_id={item.task_id}
                          account_id={currentAccount?.account_id}
                          region_alias={item.region_alias}
                        />
                      ) : (
                        // tip can only provision one instance

                        <Button
                          startIcon={
                            <IoCloudUploadOutline color="var(--fc-blue)" />
                          }
                          style={{
                            width: '100px',
                            display: trialItem?.instance_id
                              ? 'none'
                              : 'inline-flex'
                          }}
                          size="xs"
                          appearance="ghost"
                          title="Provision Instance"
                          disabled={
                            currentAccount?.user_type !== 'Master' ||
                            !IsFullAccess(currentAccount, HomeElms.fcName) ||
                            !!groupId ||
                            item.isDisableProvision
                          }
                          onClick={() => {
                            goToProvision(item.value);
                          }}
                        >
                          Provision
                        </Button>
                      )}
                    </div>
                  </Stack>
                </List.Item>
              ))}
            </List>
          ) : (
            <div
              style={{
                display: 'grid',
                placeItems: 'center',
                height: 'calc(100% - 40px)'
              }}
            >
              {!trialItem?.sn && systemData?.trial_enabled ? (
                <Button
                  startIcon={<IoCloudUploadOutline />}
                  size="md"
                  appearance="primary"
                  title="Provision Trial Instance"
                  disabled={
                    currentAccount?.user_type !== 'Master' ||
                    !IsFullAccess(currentAccount, HomeElms.fcName) ||
                    !!groupId
                  }
                  onClick={() => {
                    goToProvision('trial');
                  }}
                >
                  Provision Trial Instance
                </Button>
              ) : trialItem?.sn &&
                !trialItem?.instance_id &&
                trialItem?.task_id ? (
                <ProvisionStatusButton
                  sn={''}
                  task_id={''}
                  account_id={currentAccount?.account_id}
                  region_alias={trialItem.region_alias}
                />
              ) : trialItem?.instance_id ? (
                <div>
                  <Stack justifyContent="space-between">
                    {'Trial Instance Provisioned'}
                    <div
                      style={{
                        width: '30px',
                        display: 'grid',
                        placeItems: 'center'
                      }}
                    >
                      <CheckOutlineIcon
                        color="green"
                        title="Provision Success"
                      />
                    </div>
                  </Stack>
                </div>
              ) : (
                <div
                  style={{
                    display: 'grid',
                    placeItems: 'center',
                    fontWeight: 'bold'
                  }}
                >
                  <div>{'License not found.'}</div>
                  <div>
                    {'Please acquire a valid FortiTIP license to proceed.'}
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
};
interface IProps {
  account_id: string;
  sn: string;
  btn_text?: string;
  btn_color?: 'red' | 'green' | 'cyan';
  btn_appearance?: any;
}
export const AssetIndicator = ({
  account_id,
  sn,
  btn_text,
  btn_color,
  btn_appearance
}: IProps) => {
  const [open, setOpen] = useState<boolean>(false);
  return (
    <>
      <Button
        color={btn_color}
        onClick={() => setOpen(true)}
        className="icon-btn"
        appearance={btn_appearance || 'link'}
        style={{
          fontSize: '1em',
          padding: '0'
        }}
      >
        {btn_text}
      </Button>
      <Modal
        size={660}
        open={open}
        onClose={() => setOpen(false)}
        className="asset-detail-modal"
      >
        <Modal.Header>
          <Modal.Title>License Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <AssetDetail account_id={account_id} sn={sn} />
        </Modal.Body>
      </Modal>
    </>
  );
};
interface IAssetDetailProps {
  account_id: string;
  sn: string;
}
export const AssetDetail = ({ account_id, sn }: IAssetDetailProps) => {
  const assets = useAppSelector(selectEntitlements);
  const [data, setData] = useState<Record<string, string>[]>([]);
  useEffect(() => {
    if (assets?.[account_id] && sn) {
      const res = assets[account_id]?.entitlements?.find(
        (e: Record<string, string>) => e.serialNumber === sn
      );
      if (res?.entitlements) {
        setData(res.entitlements);
      }
    }
  }, [assets, account_id, sn]);
  return (
    <div style={{ height: '100%' }}>
      <HaLicenseDetail data={data} />
    </div>
  );
};
